import React from 'react';
import {
  Grid, Typography, Box,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import CheckedMarkSVGR from '../../../../assets/svgr/CheckedMarkSVGR';
import SingleJoinSVGR from '../../../../assets/svgr/SingleJoinSVGR';
import GroupJoinSVGR from '../../../../assets/svgr/GroupJoinSVGR';
import { FILING_STATUS } from '../../../../constants';
import './styles.scss';

const FirstStep = () => {
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const largeScreen = useMediaQuery((theme) => theme.breakpoints.up('xl'));

  const { setFieldValue, values } = useFormikContext();
  const [filingStatus, setFilingStatus] = React.useState(_.get(values, 'benefitEstimator.filingStatus'));

  const handlerRadioOnChange = (event) => {
    setFilingStatus(event.target.value);
    setFieldValue('benefitEstimator.filingStatus', event.target.value);
  };

  return (
    <Grid container spacing={2} direction='column' alignItems={!smallScreen && largeScreen ? 'flex-start' : 'center'}>
      <Typography className='steps-wizard-steps question-text no-wrap-text' pl={1} alignSelf={smallScreen && !largeScreen ? 'center' : 'flex-start'}>What is your IRS filing status?</Typography>
      <Grid container direction='row' spacing={largeScreen ? 8 : 4} className='filing-options-container'>
        <Grid item xs={6} md={smallScreen && !largeScreen ? 6 : 4}>
          <Box component='label' px={0}>
            <input
              type='radio'
              name='filingStatus'
              value={FILING_STATUS.SINGLE}
              className='card-input-element'
              onChange={handlerRadioOnChange}
              checked={filingStatus === FILING_STATUS.SINGLE}
            />
            <div className='card-radio-panel steps-card-input'>
              <SingleJoinSVGR className='svg-remove-border' />
              <CheckedMarkSVGR className='svg-checked' />
              <div className='card-radio-panel-body'>Single</div>
            </div>
          </Box>
        </Grid>
        <Grid item xs={6} md={smallScreen && !largeScreen ? 6 : 4}>
          <Box component='label'>
            <input
              type='radio'
              name='filingStatus'
              value={FILING_STATUS.JOINT}
              className='card-input-element'
              onChange={handlerRadioOnChange}
              checked={filingStatus === FILING_STATUS.JOINT}
            />
            <div className='card-radio-panel steps-card-input'>
              <GroupJoinSVGR className='svg-remove-border' />
              <CheckedMarkSVGR className='svg-checked' />
              <div className='card-radio-panel-body'>Joint</div>
            </div>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FirstStep;
